
import { useI18n } from "src/utils/lni18n";
import { TinyStudentClass } from "../domain/CourseEditModel";

export const AffectedClassesList: React.FC<{ classes: TinyStudentClass[] }> = ({
    classes
}) => {

    const { languageService: t } = useI18n();
    return (

        <table className="table table-condensed table-striped">
            <thead>
                <tr>
                    <th>
                        {t.getText("name")}
                    </th>

                    <th>
                        {t.getText("mainteacher")}
                    </th>
                    <th>
                        {t.getText("startdate")}
                    </th>
                    <th>
                        {t.getText("enddate")}
                    </th>

                    <th>
                        {t.getText("unit")}
                    </th>
                </tr>
            </thead>
            <tbody>

                {classes.map(cl => (
                    <tr key={cl.Id}>
                        <td>
                            {cl.Name}
                        </td>
                        <td>
                            {cl.MainTeacher?.FirstName} {cl.MainTeacher?.LastName}
                        </td>
                        <td className="white-space-nowrap">
                            {t.getShortDateString(cl.StartDate)}
                        </td>
                        <td className="white-space-nowrap">
                            {t.getShortDateString(cl.ClassEndDate)}
                        </td>
                        <td className="white-space-nowrap">
                            {cl.UnitName}
                        </td>
                    </tr>)
                )}

            </tbody>
        </table>


    )
}
